import styled from "styled-components";
import { fadeIn } from "../../components/Common/CommonStyles";

export const LayoutContainer = styled.div.attrs(props => ({
  'data-testid': props.testid
}))`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  animation: ${fadeIn} 0.2s ease-in;
  margin: ${({ margin }) => margin || ""};
`;

export const Section = styled.section`
  display: ${(props) => props.display || "flex"};
  align-items: ${({ align }) => {
    if (align === "left") return "flex-start";
    if (align === "center") return "center";
    if (align === "right") return "flex-end";
    return "flex-start";
  }};
  justify-content: ${(props) => props.justify || "center"};
  padding: ${(props) => props.padding || "0px"};
  flex-direction: ${(props) => props.flexDirection || "row"};
  width: ${({ width }) => width || ""};
  max-width: ${({ maxWidth }) => maxWidth || ""};
  max-height: ${({ maxHeight }) => maxHeight || ""};
  overflow-y: ${({ overflowY }) => overflowY || ""};
  align-self: ${({ alignSelf }) => alignSelf || ""};
  margin: ${({ margin }) => margin || ""};
  gap: ${({ gap }) => gap || "0px"};
`;